<template>
  <TButton
    class="w-8 h-8"
    tooltip="Non-breaking space"
    @click="editor.chain().focus().insertContent('\u00A0').run()"
  >
    <template #icon>
      <Plus />
    </template>
  </TButton>
</template>

<script setup lang="ts">
import { TButton } from "@topol/twig-ui";
import { Plus } from "@topol/icons";
import { Editor } from "@tiptap/core";

defineProps<{
  editor: Editor;
}>();
</script>
